import { FileImageOutlined } from '@ant-design/icons';

type ImagePlaceholderProps = {
    width?: number;
    height?: number;
    iconSize?: number;
};

export const ImagePlaceholder = ({ width = 50, height = 50, iconSize }: ImagePlaceholderProps) => {
    const calculatedIconSize = iconSize || Math.min(width, height) * 0.7;

    return (
        <div style={{ width, height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FileImageOutlined style={{ fontSize: calculatedIconSize }} />
        </div>
    );
};
